import Login from "../pages/Authentication";
import Dashboard from "../pages/Dashboard";
import LeadsForm from "../pages/Form";
import { Redirect } from "react-router-dom";
import Report from "../pages/Report";

const authenticatedRoute = [
    { path: '/dashboard', component: Dashboard },
    { path: '/form/:id', exact:true, component: LeadsForm},
    { path: '/form', component: LeadsForm },
    {path: '/report', component: Report},
    { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> }
]

const publicRoutes = [
    { path: '/login', component: Login }
]

export { authenticatedRoute, publicRoutes }